import { Box } from "@mui/material";
import React from "react";

const CreateUserError: React.FC = () => {

  return <Box className="login_error center">
    <h5 className="mb32 title h-error">
        エラー
    </h5>
    
    <h6 className="p-error">
      ※最初からやり直してください※
    </h6>
    
  </Box>;
};

export default CreateUserError;
